require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/utils/remove-diacritics.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/utils/remove-diacritics.legacy.js
// module id = 646
// module chunks = 31